<script setup lang="ts">
  import { computed, ref } from 'vue';
  import { VTooltip } from 'vuetify/components/VTooltip';

  import BvBtn from '@bv/components/form/button/BvBtn.vue';
  import CopyIcon from '@bv/components/icons/CopyIcon.vue';
  import { trans } from '@bv/utils';

  const parentElement = ref();

  const props = withDefaults(
    defineProps<{
      value: string;
      text?: string;
      hideText?: boolean;
    }>(),
    {
      text: undefined,
      hideText: false,
    },
  );

  const showTooltip = ref(false);

  const displayText = computed(() => props.text ?? trans('global.form.copy_trans'));

  function handleCopy() {
    if (props.value) {
      navigator.clipboard.writeText(props.value);
      showTooltip.value = true;
      setTimeout(() => {
        showTooltip.value = false;
      }, 1000);
    }
  }
</script>

<template>
  <bv-btn
    ref="parentElement"
    class="bv-copy-btn py-0"
    :disabled="!value"
    @click="handleCopy"
  >
    <v-tooltip
      v-model="showTooltip"
      location="top"
      open-on-click
      :open-on-hover="false"
      :target="parentElement"
      :text="trans('global.form.copied_trans')"
    />
    <slot>
      <copy-icon />
      <span v-if="!hideText">{{ displayText }}</span>
    </slot>
  </bv-btn>
</template>
